import { FuseAnimate, FusePageSimple } from "@fuse";
import Loading from "@fuse/components/FuseLoadable/Loading";
import _ from "@lodash";
import { Hidden, IconButton, Typography, withStyles } from "@material-ui/core";
import XAPPButton from "app/Core/Components/Button/XAPPButton";
import CatchErro from "app/Core/Components/CatchErro/CatchErro";
import PainelToggleButton from "app/Core/Components/Filter/PainelToggleButton";
import XAPPComponent from "app/Core/Components/XAPPComponent/XAPPComponent";
import * as AppActions from "app/store/actions";
import withReducer from "app/store/withReducer";
import classNames from "classnames";
import React from "react";
import { MdMenu } from "react-icons/md";
import { RiFilterFill } from "react-icons/ri";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { bindActionCreators } from "redux";
import FilterApp from "../../Core/Components/Filter/FilterApp";
import ArquivoDialog from "./ArquivoDialog";
import ArquivoLeftSidebar from "./ArquivoLeftSidebar";
import ArquivoList from "./ArquivoList";
import PastaList from "./PastaList";
import * as Actions from "./Store/Actions/ArquivoActions";
import ArquivoReducer from "./Store/Reducers/ArquivoReducer";

const filterApp = [
    { "label": "Nome", "value": "nome", "tipo": "string" },
    { "label": "Código", "value": "idarquivo", "tipo": "int" }
];

const styles = theme => ({
    title: {
        color: theme.palette.type === "dark" ? "#FFFFFF" : "#000000"
    }
});

class ArquivoApp extends XAPPComponent {

    state = {
        conditions: null,
        pasta: "" + this.props.tipo,
        codigo: null,
        pastaclasse: null,
        pastanome: null,
        tipo: this.props.tipo,
    };

    componentDidMount() {
        const { showListagem = true } = this.props;
        if (showListagem) {
            this.props.list("SELECIONAR", this.props.match.params, this.state, this.props.idfuncionalidade);
        }

        window.ArquivoOpenNew = () => {
            this.props.openNewDialog(1);
        };
    }

    componentDidUpdate(prevProps, prevState) {
        if (!_.isEqual(prevState.pasta, this.state.pasta)) {
            this.props.list("SELECIONAR", this.props.match.params, this.state, this.props.idfuncionalidade);
        }
    }

    componentWillUnmount() {
        this.props.clearArquivo();
    }

    listFilter = (_AAction, _AParams, _AFilter = null) => {
        var AFilter = null;
        if (!_.isNull(_AFilter)) {
            AFilter = { AND: [...(!_.isNull(_AFilter.AND) ? _AFilter.AND : _AFilter.OR)] };
        }
        this.props.list(_AAction, _AParams, this.state, this.props.idfuncionalidade, AFilter);
    };

    setPastaOld = () => {
        var APasta = this.state.pasta.split("/");
        APasta.splice(APasta.length - 1, 1);
        this.setPasta(APasta.join("/"));
    };

    setPasta = (_APasta) => {
        this.setState(_.set({ ...this.state }, "pasta", _APasta));
    };

    setConditions = (_AValue) => {
        this.setState({ conditions: _AValue });
    };

    render() {
        const { classes, showRemover, multiSelect, onChange, idfuncionalidade = null, tipo = null, showListagem = true, preload } = this.props;
        var { xappRouteParams } = this.props;
        if (_.isUndefined(xappRouteParams)) {
            xappRouteParams = this.props.match.params;
        }
        return (
            <React.Fragment>
                <CatchErro
                    url={this.props.match.url}
                >
                    {showListagem &&
                        <FusePageSimple
                            classes={{
                                header: "w-full flex max-h-80 h-80 min-h-80",
                                sidebarHeader: "h-128 min-h-128",
                                topBg: !_.isNull(idfuncionalidade) && "hidden"
                            }}
                            header={
                                _.isNull(idfuncionalidade) &&
                                <div className="w-full p-20">
                                    <div className="flex items-center justify-center">
                                        <Hidden lgUp>
                                            <IconButton
                                                onClick={() => this.pageLayout.toggleLeftSidebar()}
                                                aria-label="open left sidebar"
                                            >
                                                <MdMenu className="text-white" />
                                            </IconButton>
                                        </Hidden>
                                        <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                            <Typography className={classNames(classes.title, "sm:flex text-white")} variant="h6">Arquivos</Typography>
                                        </FuseAnimate>
                                        <React.Fragment>
                                            <XAPPButton
                                                key="openNewFile"
                                                onClick={() => this.props.openNewDialog(0)}
                                                icon="file"
                                                iconProps="text-24 text-white"
                                                type="Icon"
                                            />
                                            <XAPPButton
                                                key="openNewImage"
                                                onClick={() => this.props.openNewDialog(1)}
                                                icon="image"
                                                iconProps="text-24 text-white"
                                                type="Icon"
                                            />
                                        </React.Fragment>
                                        <div className="flex-1" />
                                        <PainelToggleButton />
                                        <FilterApp
                                            filters={filterApp}
                                            xappRouteParams={xappRouteParams}
                                            pesquisar={this.listFilter}
                                            pesquisaAvancada={false}
                                        />
                                        <Hidden lgUp>
                                            <IconButton
                                                onClick={() => this.pageLayout.toggleRightSidebar()}
                                                aria-label="open right sidebar"
                                            >
                                                <MdMenu className="text-white" />
                                            </IconButton>
                                        </Hidden>
                                    </div>
                                </div>
                            }
                            content={
                                <React.Fragment>
                                    {!_.isNull(idfuncionalidade) &&
                                        <div className="flex items-center">
                                            <FuseAnimate animation="transition.slideLeftIn" delay={300}>
                                                <Typography className={classNames(classes.title, "hidden sm:flex ml-12 mb-12")} color="secondary" variant="h6">Arquivos</Typography>
                                            </FuseAnimate>
                                            <React.Fragment>
                                                <XAPPButton
                                                    key="open"
                                                    onClick={() => this.props.openNewDialog(0)}
                                                    icon="file"
                                                    iconProps="text-24"
                                                    type="Icon"
                                                />
                                                <XAPPButton
                                                    key="open"
                                                    onClick={() => this.props.openNewDialog(1)}
                                                    icon="image_add"
                                                    iconProps="text-24"
                                                    type="Icon"
                                                />
                                            </React.Fragment>
                                        </div>
                                    }
                                    {preload ?
                                        <div className="xs:py-56 sm:py-128">
                                            <Loading pastDelay={true} />
                                        </div>
                                        :
                                        <React.Fragment>
                                            {!_.isNull(idfuncionalidade) &&
                                                <div className="flex">
                                                    <Hidden lgUp>
                                                        <IconButton
                                                            onClick={() => this.pageLayout.toggleLeftSidebar()}
                                                            aria-label="open left sidebar"
                                                        >
                                                            <MdMenu />
                                                        </IconButton>
                                                    </Hidden>
                                                    <div style={{ flex: 1 }} />
                                                    <Hidden lgUp>
                                                        <IconButton
                                                            onClick={() => this.pageLayout.toggleRightSidebar()}
                                                            aria-label="open right sidebar"
                                                        >
                                                            <RiFilterFill />
                                                        </IconButton>
                                                    </Hidden>
                                                </div>
                                            }
                                            <div className="flex justify-start flex-col p-16">
                                                <PastaList
                                                    xappRouteParams={xappRouteParams}
                                                    multiSelect={multiSelect}
                                                    onChange={onChange}
                                                    conditions={this.state.conditions}
                                                    setPasta={this.setPasta}
                                                    arquivoState={this.state}
                                                    setPastaOld={this.setPastaOld}
                                                    idfuncionalidade={idfuncionalidade}
                                                    tipo={tipo}
                                                />
                                                <ArquivoList
                                                    xappRouteParams={xappRouteParams}
                                                    multiSelect={multiSelect}
                                                    onChange={onChange}
                                                    conditions={this.state.conditions}
                                                    setPasta={this.setPasta}
                                                    arquivoState={this.state}
                                                />
                                            </div>
                                        </React.Fragment>
                                    }
                                </React.Fragment>
                            }
                            leftSidebarHeader={
                                _.isNull(idfuncionalidade) &&
                                <div className="flex items-center h-full p-12" />
                            }
                            leftSidebarContent={
                                <ArquivoLeftSidebar
                                    xappRouteParams={xappRouteParams}
                                    idfuncionalidade={idfuncionalidade}
                                    setcondicoes={this.setConditions}
                                />
                            }
                            onRef={instance => {
                                this.pageLayout = instance;
                            }}
                            innerScroll
                        />
                    }
                    <ArquivoDialog
                        xappRouteParams={xappRouteParams}
                        idfuncionalidade={idfuncionalidade}
                        tipo={tipo}
                        showRemover={showRemover}
                        arquivoState={this.state}
                        setPasta={this.setPasta}
                        listFilter={this.listFilter}
                    />
                </CatchErro>
            </React.Fragment>
        );
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getTags: Actions.getTags,
        list: Actions.list,
        remove: Actions.remove,
        openNewDialog: Actions.openNewDialog,
        clearArquivo: Actions.clearArquivo,
        showMessage: AppActions.showMessage,
    }, dispatch);
}

function mapStateToProps({ Arquivo }) {
    return {
        Arquivo: Arquivo,
        preload: Arquivo.preload
    };

}

export default withReducer("Arquivo", ArquivoReducer)(withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(ArquivoApp))));
